import request from '@/utils/request.ts'

export const getArticles = (params: any) =>
  request({
    url: '/devicetype/getlistbycondition',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const addEquipment = (params: any) =>
  request({
    url: '/devicetype/addDeviceType',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })

export const editForm = (params: any) =>
  request({
    url: `/devicetype/updateDeviceType`,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const getinfo = (params: any) =>
  request({
    url: `/devicetype/getDeviceTypeInfoById`,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })